document.addEventListener("DOMContentLoaded", () => {
  // $(document).on("click", ".ng-input", function(){
  //   const id = $("input[name='id']").val()
  //   const data = {}
  //   const tr = $(this).closest("tr")

  //   data.internal_part_id = tr.attr("internal_part_id") 
  //   data.part_name = tr.attr("part_name");

  //   ["eng_product_id", "eng_material_id", "eng_packaging_id"].forEach(function(d){
  //     console.log(d)
  //     if (tr.attr(d) != undefined) {
  //       data[d] = tr.attr(d)
  //     } else {
  //       data[d] = null
  //     }
  //   })

  //   var url = "/dashboard/ngs/"+ id +"?";
  //   ["internal_part_id", "part_name", "eng_product_id", "eng_material_id", "eng_packaging_id"].forEach(function(d){
  //     url += `${d}=${data[d]}&`
  //   })

  //   loadModal({
  //     title: `Pilih NG | ${data.internal_part_id} - ${data.part_name}`,
  //     url: url
  //   })
  // })

  $(document).on("click", ".ng-input", function(){
    const id = $("input[name='id']").val()
    const data = {}
    const tr = $(this).closest("tr")

    data.internal_part_id = tr.attr("internal_part_id") 
    data.part_name = tr.attr("part_name");
    data.type = tr.attr("type")

    var url = `/dashboard/ngs/${id}?type=${data.type}&internal_part_id=${data.internal_part_id}&part_name=${data.part_name}&`
    if (data.type == "main"){
      url += `eng_product_id=${tr.attr("eng_product_id")}`;
    } else {
      ["eng_product_id", "eng_material_id", "eng_packaging_id"].forEach(function(d){
        if (tr.attr(d) != undefined) {
          data[d] = tr.attr(d)
        } else {
          data[d] = null
        }
      });

      ["internal_part_id", "part_name", "eng_product_id", "eng_material_id", "eng_packaging_id"].forEach(function(d){
        url += `${d}=${data[d]}&`
      })
    }

    loadModal({
      title: `Pilih NG | ${data.internal_part_id} - ${data.part_name}`,
      url: url
    })
  })

  $(document).on("click", ".ng-select", function(){
    const ng_id = $(this).attr("ng_id")
    const ng_name = $.trim($(this).text())

    $("input[name='product_ng_log[qc_ng_category_id]']").val(ng_id)
    $("input[name='ng_type']").val(ng_name)
    
    $("#ngpage1").attr("hidden", "hidden")
    $("#ngpage2").removeAttr("hidden")
  })

  $(document).on("change", "input[class='ng_keypart_checkbox']", function(){
    const $this = $(this)
    const $tr = $this.closest("tr")

    // $tr.find("input[flexible]").attr("hidden", "hidden")
    $tr.find("input[flexible]").attr("disabled", "disabled")
    $tr.attr("style", "background: #eee")

    if ($this.prop("checked")){
      // $tr.find("input[flexible]").removeAttr("hidden")
      $tr.find("input[flexible]").removeAttr("disabled")
      $tr.removeAttr("style")
    }
  })

  $(document).on("click", ".ng-back-after-select", function(){
    $("#ngpage1").removeAttr("hidden")
    $("#ngpage2").attr("hidden", "hidden")
  })
})